// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import Axios from 'axios';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/styles/icon.css';
import '!style-loader!css-loader!less-loader!./assets/styles/helper.less';
// import './components/common/directives';
import "babel-polyfill";
require("./utils/helper");

import Http from "./utils/http";
import VueQriously from 'vue-qriously';
// import preview from 'vue-photo-preview'
// import 'vue-photo-preview/dist/skin.css'

// Vue.use(preview);

Vue.use(VueQriously);
Vue.use(Http);

// Vue.prototype.$server = process.env.NODE_ENV === 'production' ? "http://47.75.220.232:6001" : "http://localhost:8080";

Vue.config.productionTip = false;

Vue.use(ElementUI, {
  size: 'small'
});


router.beforeEach(function (to,from,next) {
  if (!localStorage.getItem('username') && to.path !== "/login") {
    return next({
      path: '/login',
      query: {redirect: to.fullPath}
    })
  }
  // } else {
  //   next()
  // }
  if(to.name === "DeviceHistory" && !to.params.uid){
    return next("/data")
  }
  next()
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js